import { useContext, useEffect, type FunctionComponent } from 'react';
import { trackPageLoad } from '@fff-web/fff-analytics';
import { Button, ButtonLink } from '@fff-web/fff-ui-shared';
import { putReactivateSubscription } from '../../services/questionnaire';
import buttonLabels from '../../utils/buttonLabels';
import { pages } from '../../utils/pages';
import { redirectToDashboard } from '../../utils/redirectMethods';
import fireReactivationCompleted from '../../utils/segment/fireReactivationCompleted';
import { DynamicTextContext } from '../context/DynamicTextContext';
import * as styles from './CancelSubscriptionFinal.module.css';

interface CancelSubscriptionFinalProps {
  subscriptionType: string;
  subscriptionState: string;
}

const CancelSubscriptionFinal: FunctionComponent<CancelSubscriptionFinalProps> = ({
  subscriptionType,
  subscriptionState,
}) => {
  const { dynamicText } = useContext(DynamicTextContext);

  useEffect(() => {
    document.title = pages.CANCEL_SUBSCRIPTION_FINAL.title;
    dynamicText?.wooUserId && trackPageLoad();
  }, [dynamicText?.wooUserId]);

  const handleReactivate = async () => {
    const isExpired = subscriptionState === 'EXPIRED';
    putReactivateSubscription()
      // TO DO: add status of reactivation - success, payment fail, technical fail
      // once API team updates the response error code for this endpoint
      .finally(() => fireReactivationCompleted(isExpired, subscriptionType))
      .finally(() => redirectToDashboard());
  };

  return (
    <div className={styles.cancelSubscriptionFinalContainer}>
      <div className={styles.cancelSubscriptionFinalContent}>
        <div className={styles.checked}>
          <i className="fal fa-check-circle" />
        </div>
        <h1 className={styles.title}>Your Subscription Has Been Cancelled</h1>
        <p className={styles.note}>You will receive a confirmation email.</p>
        <p className={styles.extraNote}>
          Note: You will still receive any boxes that you paid for before canceling. Annual
          subscription cancelation requests will go into effect at the end of the annual term.
        </p>
        <p className={styles.question}>Changed your mind? You can reactivate now!</p>
        <div className={styles.reactivateButton}>
          <Button onClick={handleReactivate}>{buttonLabels.REACTIVATE}</Button>
        </div>
        <div className={styles.backHomeLink}>
          <ButtonLink label={buttonLabels.BACK_HOME} onClick={redirectToDashboard} />
        </div>
      </div>
    </div>
  );
};

export default CancelSubscriptionFinal;
